import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * チェックフラグカラム
 *【内容:content:string】
 *【非活性:disabled:boolean】
 *【チェックフラグ:checked:boolean】
 *【全件選択ボタン:btnFlg:boolean】
 *【表示条件:visible:boolean】
 *【更新対象:changeTarget:boolean = true】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-checkflag-column',
  templateUrl: './checkflag-column.html',
  styles: [`
    
  `]
})
export class CheckflagColumn extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * チェックフラグの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * チェックフラグに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * チェックフラグ
   */
  @Input() checked:boolean

  /**
   * 全件選択ボタン
   */
  @Input() btnFlg:boolean

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 更新対象
   */
  @Input() changeTarget:boolean = true

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  updateChecked(event:Event, index:number):void {
    const e = {id:this.id, type:'change', source:'event', index:index}
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this.checked,
      e,
      `update by ${this.id}`,
    ))
    if (this.changeTarget) {
      this.records[index]['_changed'] = true
    }
    this.on(e, index)
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/checkflag-column/checkflag-column.component.ts